// extracted by mini-css-extract-plugin
export default {"container":"BaseMap_container__3KKN6"};